import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";
export const findpreAfterSalesOrder = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/engineering_order?` + params,
    method: "GET",
  });
};

// downloadExcelPureWaterGoods，下载服务清单
export const downloadExcelPureWaterGoods = (params) => {
  params = parseParam(params);
  return request({
    url:
      `${baseUrl}/joins-sales-cloud/v1/preFilter/downloadExcelPureWaterGoods?` +
      params,
    method: "GET",
    responseType: "blob",
  });
};
//退回原因
export const refund = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/preFilter/refund`,
    method: "POST",
    data: data,
  });
};
// 修改
export const updateAfterSalesOrder = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/update`,
    method: "PUT",
    data: params,
  });
};
export const findUserList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-basic/v1/user/findUserList?` + params,
        method: 'GET'
    })
}
export const getAfterSalesOrder = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration?id=` + params,
    method: "GET",
  });
};
export const getDownloadCode = (params) => {
  return request({
    url: `${baseUrl}/joins-product/v1/app_product/downloadMiniProgramCodeImageV2`,
    method: "POST",
    responseType: "blob",
    data: params,
  });
};
// 获取代理商Id
export const getRootDepartmentId = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/department/getRootDepartmentId`,
    method: "GET",
  });
};